import React, { useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import Swal from 'sweetalert2'; // Import SweetAlert
import * as XLSX from 'xlsx';
import { Backdrop, Button, Dialog, DialogContent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'; // Import CircularProgress from Material-UI

import { useFilter } from '../../layouts/dashboard/FilterProvider';
import apiFunctions from '../../API/api';
import WhatsappApiFunctions from '../../API/whatsapp';

const DigitalMessageReport = ({ selectedStore }) => {
  const { filter } = useFilter();

  const [loading, setLoading] = useState(false);
  const Popup = () => {
    Swal.fire({
      title: 'Download Report',
      text: 'Do you want to download the report?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, download it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        handleDownload();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User clicked "No, cancel"
        Swal.fire('Cancelled', 'The download request was cancelled.', 'info');
      }
    });
  };
  function formatToIST(dateString) {
    // Convert the input date string to a Date object
    const date = new Date(dateString);

    // Get the individual components
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Determine AM or PM
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours %= 12;
    hours = hours || 12; // If hours is 0, make it 12

    // Format the time to include leading zeros
    const formattedTime = `${hours}:${minutes < 10 ? `0${minutes}` : minutes} ${ampm}`;

    // Get the year (last two digits)
    const year = `${date.getFullYear()}`.slice(-2);

    // Return the formatted date and time string
    return `${date.getDate()}/${date.getMonth() + 1}/${year} ${formattedTime}`;
  }
  const handleDownload = async () => {
    try {
      setLoading(true);
      const data = await WhatsappApiFunctions.getMessageDownloadReport2(filter, selectedStore);
      console.log('report', data.Contact);
      // const store = await apiFunctions.getStoreCounts();

      // response.data; // Replace with the data from your API

      // Convert data to worksheet
      console.log(data, 'data');
      //   console.log(store1, 'store1');
      //   console.log(locationSheet, 'locationSheet');
      // const worksheet1 = XLSX.utils.json_to_sheet(data.Contact); // removed {header: columns} after, data

      const worksheet1 = XLSX.utils.json_to_sheet(
        data.Contact.map((row) => {
          return {
            // Only include the columns you want
            'Template Name': row.TemplateName,
            Number: row.Number,
            Status: row.MessageStatus,
            'Created Time': formatToIST(row.CreatedAt),
            'Event Name': row.EventsName,
            'Message Error': row.ErrorMsg,
            // Add more columns as needed
          };
        })
      );

      // Create a new workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet1, 'User Details');

      // Generate a binary string from the workbook
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      setLoading(false);
      Swal.fire({
        icon: 'info',
        title: 'Download Started',
        text: 'Your download has started.',
        showConfirmButton: false, // Prevent the user from closing it manually
      });

      // Create a Blob from the buffer and download the file
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = 'WhatsApp Tracker.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      setLoading(false);
      console.error('Error downloading Excel:', error);
    }
  };

  return (
    <div>
    <Button onClick={Popup} variant="contained" color="primary" size="large" sx={{ height: '40px', whiteSpace: 'nowrap', backgroundColor: '#D24A61', color: '#ffffff', '&:hover': { backgroundColor: '#e3272c' } }}>
        <AiOutlineDownload style={{ width: 'auto', height: '22px' }} /> &#160; Download Report 
      </Button>

      <Dialog open={loading} maxWidth="false">
        <DialogContent style={{ background: 'white', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress style={{ color: 'black' }} size={60} thickness={4} />{' '}
            {/* Display the loader when loading is true */}
          </div>
          <br />
          Generating Report...
        </DialogContent>
      </Dialog>
      <Backdrop open={loading} />
    </div>
  );
};
export default DigitalMessageReport;
